import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import axios from "axios";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Tick from "../../assets/svg/Tick";

import { useSearchParams } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { useAuth } from "../../contexts/AuthContext";
import { listingStates } from "../../util/flStates";

import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import styles from "./LandlordPaymentSuccessView.module.css";

const LandlordPaymentSuccessView = () => {
  const { accessToken } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  var token = searchParams.get("rToken");
  const listingIdFromUrl = searchParams.get("listingId");
  const listingUrlFromUrl = searchParams.get("listingUrl");
  const listingTypeFromUrl = searchParams.get("listingType");
  
  const [isLoading, setIsLoading] = useState(true);
  const [listingData, setListingData] = useState({
    listingId: listingIdFromUrl || null,
    listingUrl: listingUrlFromUrl || "",
    listingType: listingTypeFromUrl || ""
  });

  const getSpecialString = (listingType) => {
    switch (listingType) {
      case listingStates.rent:
        return "Rent-Homes";
      case listingStates.sell:
        return "Buy-Homes";
      default:
        return "listings";
    }
  };

  // Get listing data from location state if available
  useEffect(() => {
    if (location.state?.listingId) {
      console.log("Found listing data in location state:", location.state);
      setListingData({
        listingId: location.state.listingId,
        listingUrl: location.state.listingUrl || "",
        listingType: location.state.listingType || ""
      });
    }
  }, [location.state]);

  useEffect(() => {
    const updatePaymentSuccess = async () => {
      try {
        const requestData = {
          token: token,
        };

        console.log("Sending request with token:", token);
        
        // Check if accessToken starts with Bearer
        const authToken = accessToken && !accessToken.startsWith("Bearer ") 
          ? `Bearer ${accessToken}` 
          : accessToken;
        
        const response = await axios.post(
          `${import.meta.env.VITE_BACKEND_URL}/payment/update-success`,
          requestData,
          {
            headers: { Authorization: authToken },
          }
        );

        console.log("Payment success response:", response.data);
        if (response.status === 200) {
          if (
            response.data &&
            "success" in response.data &&
            response.data.success
          ) {
            // Set listing data if available in response
            if (response.data.listing) {
              setListingData({
                listingId: response.data.listing.id || null,
                listingUrl: response.data.listing.url || response.data.listing.listing_url || "",
                listingType: response.data.listing.type || response.data.listing.listing_type || ""
              });
            } else if (response.data.listingId) {
              // Alternative response format
              setListingData({
                listingId: response.data.listingId,
                listingUrl: response.data.listingUrl || "",
                listingType: response.data.listingType || ""
              });
            }
          }
        }
      } catch (error) {
        console.error("Error during update:", error);
        // Even if there's an error, try to extract listing data from URL params or location state
        const stateData = location.state || {};
        if (listingIdFromUrl || stateData.listingId) {
          setListingData({
            listingId: listingIdFromUrl || stateData.listingId || null,
            listingUrl: listingUrlFromUrl || stateData.listingUrl || "",
            listingType: listingTypeFromUrl || stateData.listingType || ""
          });
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (!token) {
      // this means that some tampering must have been done
      setIsLoading(false);
    } else {
      updatePaymentSuccess();
    }
  }, [token, accessToken, location.state, listingIdFromUrl, listingUrlFromUrl, listingTypeFromUrl]);

  // Function to handle the View Live Listing button click
  const handleViewListing = () => {
    // Fall back to listings page if we don't have a URL
    if (!listingData?.listingUrl) {
      navigate("/MyFirstLand?category=listings");
      return;
    }
    
    // Get the special string based on listing type
    const specialString = getSpecialString(listingData.listingType || "");
    
    // Try to use the actual host origin, with a fallback
    const baseUrl = import.meta.env.VITE_FRONTEND_URL; 
    
    // // Log what we're about to open
    // console.log(`Opening listing: ${baseUrl}/${specialString}/${listingData.listingUrl}`);
    
    // Open the URL in a new tab
    window.open(
      `${baseUrl}/${specialString}/${listingData.listingUrl}`,
      "_blank"
    );
  };

  return (
    <div>
      <Navbar />
      <div className={styles.pageContainer}>
        {isLoading ? (
          <Loading />
        ) : token ? (
          <Box
            sx={{
              textAlign: "center",
              padding: "2rem",
              border: "1px solid #4CAF50",
              borderRadius: "8px",
              backgroundColor: "#E8F5E9",
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#4CAF50" }} />
            <Typography variant="h4" sx={{ color: "#4CAF50", marginTop: "1rem" }}>
              Thank you for premium listing your property with us!
            </Typography>
            <div style={{marginTop: "10px"}}>
              Your premium upgrade for this listing is successful!
            </div>
            <Box sx={{ marginTop: "2rem" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/landlord")}
                sx={{ margin: "0.5rem" }}
              >
                Add Another Property
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => navigate("/MyFirstLand?category=listings")}
                sx={{ margin: "0.5rem" }}
              >
                View All Listings
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleViewListing}
                sx={{ margin: "0.5rem" }}
              >
                View Live Listing
              </Button>
            </Box>
          </Box>
        ) : (
          <div>Unauthorised Access!</div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default LandlordPaymentSuccessView;
